module.exports = __webpack_public_path__ + "img/folder-drive.7ef0816f.svg";